"use client";

import { LegalDocumentsPage } from "@/components/sections/LegalDocumentsPage";
import { legalData } from "@/data/legal-notice";

export default function MentionsLegalesPage() {
  return (
    <LegalDocumentsPage
      bannerTitle="Mentions légales"
      eyebrow="Cadre juridique"
      intro="Retrouvez ici l'identité de l'éditeur, les informations d'hébergement et les engagements légaux liés au site Espace Cadet."
      articles={legalData}
    />
  );
}
